import { gql } from '@apollo/client';

const SIGN_UP_MUTATION = gql`
  mutation SignUpMutation(
    $email: String!
    $password: String!
    $source: RegistrationSource
  ) {
    userSignUp(
      email: $email
      password: $password
      registration_source: $source
    ) {
      id
      model_id
    }
  }
`;

export default SIGN_UP_MUTATION;
